<div [hidden]="!isLoading" class="text-xs-center text-center loader-div">
  <div class="loader"></div>
</div>

